import Http from '../utils/http'

export const getNumbers = (params = {}) => Http.get(`/reports/dashboard/numbers`, { params })

export const getProjection = (params = {}) => Http.get(`/reports/dashboard/projection`, { params })

export const getPerception = (params = {}) => Http.get(`/reports/dashboard/perceptions`, { params })

export const getOpenByMembers = (params = {}) => Http.get(`/reports/dashboard/open-deals`, { params })

export const getEmails = (params = {}) => Http.get(`/reports/dashboard/emails`, { params })

export const getFollowUps = (params = {}) => Http.get(`/reports/dashboard/follow-ups`, { params })

export const getAmountDeals = (params = {}) => Http.get(`/reports/dashboard/amount-deals`, { params })



// WEBPACK FOOTER //
// ./src/services/dashboard.js